import React, { useState, useEffect, useRef, useCallback } from 'react';
import { ButtonC } from 'Common/Buttons';
import Axios from 'functions/Axios';
import {
  Addfolder,
  GET_ASSET_TYPE_FILTER_DATA,
  GET_FOLDER_COLORS,
  GET_INSIDE_FOLDER_DATA,
  ListofAllAssetsURL,
  folderdata,
  getSingleFolder,
} from '../DAM_API/urls';
import { Assitdata } from './assitdata';
import Uploadfile from '../Uploadfile';
import { Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import close from '../../../assets/V2-images/close.svg';
import SpinnerLoader from './../../SpinnerLoader';
import { useLocation } from 'react-router-dom';
import { Viewbuttonfolderv2 } from 'Common/Viewbuttonfolder/index-v2';
import FolderData from '../Folders';
import { toast } from 'react-toastify';
import { SVG } from 'Common/commonsvg';
import { GridFolderData } from '../Folders/gridfolder';
import InputC from 'Common/Inputs/index.tsx';
import { DAM_SVG } from '../DamAssets';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import {
  setInsideFolderData,
  SetSelctedFoldersData,
  SelectedAssetData,
  setInnerFolderDetails,
} from 'actions/damActions';
import Nodatacomponent from 'components/Nodatacomponent';
import CommonSidePortal from 'Common/SidePortal/SidePortal';
import SelectionActions from '../Components/Featured/selectionActions';
import DropZone from 'Common/Dropzone';
import CommonTableDrived from '../Components/Featured/CommonTableDrived';
import CommonTable from '../Components/Featured/CommonTable';
import { useContainerRef } from 'context/ContainerRefContext';
import { useDownloadAssets } from '../../../context/DownloadAssetsContext';
import { splitUploadRequests, runUploadRequests } from 'functions/Upload';
import { MODULE_IDS, useHasAccess, USER_RIGHTS } from 'actions/userActions';
import SearchUI from './SearchUI';
import AdvancedSearch from './AdvancedSearch';
import { createEmptyRow } from './AdvancedSearch/fields';
import TabToggle from '../NewUiCommans/TabToggle';
import activegrid from '../../../assets/activeGrid.svg';
import inactivegrid from '../../../assets/inactivegrid.svg';
import activelist from '../../../assets/activelist.svg';
import inactivelist from '../../../assets/inactivelist.svg';

export const sortOptions = [
  { id: 1, name: 'Latest', value: 1, label: 'Latest' },
  { id: 2, name: 'Oldest', value: 2, label: 'Oldest' },

  { id: 3, name: 'Last Modifed', value: 3, label: 'Last Modifed' },
  { id: 4, name: 'Name: A-Z', value: 4, label: 'Name: A-Z' },
  { id: 5, name: 'Name: Z-A', value: 5, label: 'Name: Z-A' },
];

export const uploadFiless = async (UploadFiles, acceptedFiles, folderId) => {
  try {
    if (acceptedFiles?.length > 2000) {
      toast.info('You cannot upload a folder which has more than 2000 files at a time.');
      return;
    }

    // Every asset and every folder is its own request, so each gets its own
    // activityId — and its own row in the progress panel.
    const groups = splitUploadRequests(acceptedFiles);

    await runUploadRequests(
      groups.map((group) => () => {
        const data = new FormData();

        group.files.forEach((f, index) => {
          data.append(`files[${index}]`, f);
          data.append(`isVideo[${index}]`, f.type.includes('video'));
          data.append(`isStreamable[${index}]`, f.type.includes('video'));

          if (f.path?.includes('/')) {
            const cleanPath = f.path.replace(/^(\.\/|\/)/, '');
            data.append(`relativePaths[${index}]`, cleanPath);
          } else {
            data.append(`relativePaths[${index}]`, '');
          }
        });

        if (folderId !== null && folderId !== undefined) {
          data.append('folderId', folderId);
        }

        return UploadFiles(data, group.files.length);
      }),
    );
  } catch (err) {
    console.error(err);
  }
};

const AssetsData = ({
  fromBrandAssets,
  setselectedfolderId,
  selectedfolderid,
  single,
  accept,
  trash,
  scrollRef,
}) => {
  const { containerRef: listInnerRef, setScrollHandler } = useContainerRef();
  const { UploadFiles: UploadFilesContext, refreshRef } = useDownloadAssets();
  const hasDAMAccess = useHasAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess, USER_RIGHTS.Editor]);
  const hasFullDAMAccess = useHasAccess(MODULE_IDS.DAM, [USER_RIGHTS.FullAccess]);

  const [assets, setAssets] = useState({ files: [] });
  console.log(assets, 'assetsassetsassets');

  const [selectedFormats, setSelectedFormats] = useState([]);
  const [selectorientation, setselectorientation] = useState([]);
  const [selectassettype, setselectassettype] = useState([]);
  const [filterAssetType, setfilterAssetType] = useState();
  const [selectedColor, setSelectedColor] = useState([]);
  const [selectedFace, setSelectedFace] = useState();
  const [createdon, setcreatedon] = useState([]);
  const [selectdate, setselectdate] = useState('');
  const [selecttDateValidator, setSelectDateValidator] = useState({});
  const [uploadedData, setUploadedData] = useState([]);
  const [assetTags, setAssetsTags] = useState();
  const [tagValue, setTagValue] = useState([]);
  const [modal, setModal] = useState(false);
  const [showupload, setshowupload] = useState(false);
  const [loadedData, setLoaded] = useState(0);
  const [totalData, setTotal] = useState(0);
  const [disableDropBox, setDisableDropBox] = useState(false);
  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [files, setFiles] = useState([]);
  const [previewFlag, setPreviewFlag] = useState(false);
  const [folderId, setFolderId] = useState(null);
  const [isCollectionAdded, setIsCollectionAdded] = useState(false);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [isfirstLoad, setIsFirstLoad] = useState(true);
  const location = useLocation();
  const state = location.state;
  const collectionID = state ? state.collectionID : null;
  const collection_name = state ? state.collection_name : null;
  const [Designationdata, setDesignationdata] = useState(null);
  const [iscustomValue, setIsCustomValue] = useState(false);
  const [searchExtesionValue, setSearchExtensionValue] = useState('');
  const [isExtension, setIsExtension] = useState(false);
  const [filtereddata, setfiltereddata] = useState([]);
  const [datafilter, setdatafilter] = useState([]);
  const [folderselect, setfolderselect] = useState([]);
  const [subfolder, setsubfolder] = useState([]);
  const [addcollection, setaddcollection] = useState(false);
  const [textvalue, settextvalue] = useState();
  const [activeId, setActiveId] = useState();
  const [openFolderModal, setOpenFolderModal] = useState(false);
  const { isInsideFolder, insideFolderId, selectedAssets, selectedFolders } = useSelector(
    (state) => state.dam,
  );
  const [visualImageData, setVisualImageData] = useState();
  const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const [currentModalFolderName, setCurrentModalFolderName] = useState('');
  const [search, setSearch] = useState('');
  const [debouncedSearch, setDebouncedSearch] = useState('');
  const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);
  // Rows are the panel's working copy; `advancedFilters` is what has actually
  // been applied to the search request.
  const [advancedRows, setAdvancedRows] = useState([createEmptyRow()]);
  const [advancedFilters, setAdvancedFilters] = useState([]);
  const [openFolderSection, setOpenFolderSection] = useState(false);
  const [assetToken, setAssetToken] = useState('123');
  const [openAdditionDialog, setOpenAdditionDialog] = useState(false);
  // const listInnerRef = useRef();
  const [metaData, setMetaData] = useState({
    currentPage: 1,
    isScrolling: false,
    external: 'la la la ',
  });
  const [Paginationdata, setPaginationdata] = useState(null);
  const [statsChecker, setStatsChecker] = useState(false);
  const [isAvailableData, setisAvailableData] = useState(true);
  const [allFoldersData, setAllFoldersData] = useState([]);
  const [imageSearchModal, setImageSearchModal] = useState(false);
  const [imageSearchLoading, setImageSearchLoading] = useState(false);
  const [selectedTab, setSelectedTab] = useState(1);
  const [visualSearchModal, setVisualSearchModal] = useState({
    open: false,
    result: '',
    data: '',
  });

  useEffect(() => {
    setSelectedTab(Number(localStorage?.getItem?.('damAssetsView') || 1));
  }, []);

  const [sorting, setSorting] = useState(sortOptions[0]);

  const [loadingValue, setLoadingValue] = useState(false);
  const [mode, setMode] = useState(1);

  const wrapperRef = useRef(null);
  const box1Ref = useRef(null);
  const box2Ref = useRef(null);
  const box3Ref = useRef(null);

  // const [selectedfolderid , setselectedfolderId] = useState(null)

  const handleDelete = (ids) => {
    const idArray = Array.isArray(ids) ? ids : [ids];

    setAssets((prev) => ({
      ...prev,
      files: prev.files.filter((f) => !idArray.includes(f.damFileId)),
    }));

    dispatch(SelectedAssetData(selectedAssets.filter((f) => !idArray.includes(f.damFileId))));
  };

  const datashow = async (IsErase = false) => {
    setIsLoading(true);

    try {
      const { isCustom, ...filteredSelectDate } = selectdate || {};
      const result = {};

      const infoList = selectassettype?.filter(
        (item) => typeof item === 'object' && item?.extensions,
      );

      const extList = selectassettype?.filter((item) => typeof item === 'string');

      infoList?.forEach((info) => {
        result[info.type] = [];
      });

      extList?.forEach((ext) => {
        infoList?.forEach((info) => {
          if (info.extensions.includes(ext)) {
            result[info.type].push(ext);
          }
        });
      });

      /** ---------------------------
       * FETCH DATA
       * --------------------------- */

      let collectedFiles = [];
      let lastResponse = null;

      const pagesToFetch = IsErase || !metaData.isScrolling ? metaData.currentPage : 1;

      for (let i = 0; i < pagesToFetch; i++) {
        const pageNo = IsErase || !metaData.isScrolling ? i : metaData.currentPage - 1;

        const { data } = await Axios.post(ListofAllAssetsURL, {
          pageNo,
          rowSize: 30,
          folderIds: folderselect,
          orientations: selectorientation,
          dominantColor: selectedColor,
          filterTypeExtension: result,
          personCount: selectedFace,
          uploadedBy: uploadedData?.includes('By me')
            ? true
            : uploadedData?.includes('By Others')
              ? false
              : '',
          ...(selectdate?.isCustom
            ? filteredSelectDate
            : selectdate
              ? { startDate: selectdate }
              : {}),
          tagList: tagValue,
          searchKeyword: isExtension ? searchExtesionValue : search,
          trash: trash ? true : false,
          order: sorting?.value,
        });

        lastResponse = data;

        const files =
          data?.data?.files?.map((item) => ({
            ...item,
            damFileId: item.assetId,
            isSelected: false,
          })) || [];

        collectedFiles = [...collectedFiles, ...files];
      }

      /** ---------------------------
       * MERGE LOGIC
       * --------------------------- */

      const finalFiles =
        IsErase || !metaData.isScrolling ? collectedFiles : [...assets.files, ...collectedFiles];

      setAssets({ files: finalFiles });

      /** ---------------------------
       * SELECTED ASSET SYNC
       * --------------------------- */

      const selectedMap = new Map(selectedAssets?.map((item) => [item.damFileId, item]));

      const mergedSelected = finalFiles.map((item) => ({
        ...item,
        isSelected: selectedMap.get(item.damFileId)?.isSelected ?? false,
      }));

      dispatch(SelectedAssetData(mergedSelected));

      /** ---------------------------
       * META
       * --------------------------- */

      setMetaData((prev) => ({
        ...prev,
        isScrolling: false,
        totalPages: lastResponse?.metadata?.totalAmountOfPages,
      }));

      setPaginationdata(lastResponse?.metadata);
      setAssetToken(lastResponse?.assetToken);

      setisAvailableData(lastResponse?.metadata?.totalAmountOfPages > metaData.currentPage);

      setStatsChecker(true);
    } catch (error) {
      console.error('Error fetching assets:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const getAllSearchData = async (value) => {
    const noFilters =
      !search &&
      selectorientation?.length === 0 &&
      selectedColor?.length === 0 &&
      folderselect?.length === 0 &&
      !selectedFace &&
      (!uploadedData || uploadedData.length === 0) &&
      (!selectdate ||
        (typeof selectdate === 'object'
          ? Object.keys(selectdate).length === 0
          : String(selectdate).trim().length === 0)) &&
      (!tagValue || tagValue.length === 0) &&
      (!selectassettype || selectassettype.length === 0) &&
      searchExtesionValue?.length === 0 &&
      advancedFilters?.length === 0;

    if (noFilters && selectdate !== 0) {
      getAllFolders();
      datashow();
      return;
    }

    !insideFolderId && setIsLoading(true);

    if (search && search?.length > 0 && search?.length < 3) {
      setIsLoading(false);
      return;
    }
    try {
      const { isCustom, ...filteredSelectDate } = selectdate || {};
      let resulta = {};

      const infoList = selectassettype.filter(
        (item) => typeof item === 'object' && item.extensions,
      );
      const extList = selectassettype.filter((item) => typeof item === 'string');
      infoList.forEach((info) => {
        resulta[`"${info.type}"`] = [];
      });

      extList.forEach((ext) => {
        infoList.forEach((info) => {
          if (info.extensions.includes(ext)) {
            resulta[`"${info.type}"`].push(ext);
          }
        });
      });
      let result;

      if (insideFolderId && noFilters) {
        result = await Axios.get(getSingleFolder + insideFolderId);
      } else {
        result = await Axios.post(`${GET_INSIDE_FOLDER_DATA}`, {
          searchKeyword: isExtension ? searchExtesionValue : search,
          isAI: mode === 2,
          orientations: selectorientation,
          ...(!isExtension && {
            filterTypeExtension: resulta,
          }),
          dominantColor: selectedColor,
          folderIds: folderselect,
          personCount: selectedFace,
          uploadedBy: uploadedData?.includes('By me')
            ? true
            : uploadedData?.includes('By Others')
              ? false
              : '',
          ...(selectdate?.isCustom ? { ...filteredSelectDate } : { startDate: `${selectdate}` }),
          // ...(insideFolderId && {
          //   parentFolderId: insideFolderId,
          // }),
          tagList: tagValue,
          clientId: user?.userID,
          trash: trash ? true : false,
          order: sorting?.value,
          ...(advancedFilters?.length > 0 && { advancedFilters }),
        });
      }

      !insideFolderId && setIsLoading(false);

      const _folders_data = {
        data: {
          folders: [
            {
              folders: result?.data?.data?.folders,
            },
          ],
        },
      };

      dispatch(
        SetSelctedFoldersData(
          result?.data?.data?.folders?.map((item) => ({
            ...item,
            isSelected: false,
          })),
        ),
      );
      setAllFoldersData(_folders_data);
      setAssets(result?.data?.data);
      dispatch(SelectedAssetData(result?.data?.data?.files));
    } catch (err) {
      !insideFolderId && setIsLoading(false);
      console.error(err);
    }
  };

  useEffect(() => {
    if (isfirstLoad) {
      setIsFirstLoad(false);
      fetchFolders();
      dispatch(setInsideFolderData(true));
      getAllFolders();
      datashow();
      return;
    } else {
    }
    const delaysearcfun = setTimeout(async () => {
      getAllSearchData();
    }, 500);
    return () => clearTimeout(delaysearcfun);
  }, [
    selectedFormats,
    selectorientation,
    selectassettype,
    selectdate,
    folderselect,
    tagValue,
    debouncedSearch,
    selectedColor,
    assetTags,
    selectedFace,
    uploadedData,
    searchExtesionValue,
    metaData?.currentPage,
    search,
    refreshRef,
    trash,
    sorting,
    advancedFilters,
  ]);

  useEffect(() => {
    handlereset();
  }, [trash]);

  const handleOrientationChange = (orientation) => {
    setselectorientation((prevOrientations) => {
      if (prevOrientations.includes(orientation)) {
        return prevOrientations.filter((item) => item !== orientation);
      } else {
        return [...prevOrientations, orientation];
      }
    });
  };

  const handleAssetType = (assettype) => {
    setselectassettype((prevtype) => {
      if (prevtype.includes(assettype)) {
        return prevtype.filter((item) => item !== assettype);
      } else {
        if (assettype?.extensions) {
          return [...prevtype, assettype];
        } else {
          return [...prevtype, assettype];
        }
      }
    });
  };

  const today = new Date();

  const handlereset = () => {
    setIsFirstLoad(true);
    setSelectedFormats([]);
    setfiltereddata([]);
    setIsCustomValue(false);
    setselectorientation([]);
    setSelectDateValidator([]);
    setselectassettype([]);
    setselectdate('');
    setcreatedon([]);
    setIsExtension(false);
    setfolderselect([]);
    setSelectedColor([]);
    setUploadedData([]);
    setSelectedFace();
    setTagValue([]);
    setSearch('');
    clearAdvancedSearch();
  };

  const clearAdvancedSearch = () => {
    setAdvancedRows([createEmptyRow()]);
    setAdvancedFilters((previous) => (previous.length ? [] : previous));
  };

  useEffect(() => {
    const url = window.location.href;
    const urlObj = new URL(url);

    const orientation = urlObj.searchParams.get('orientation');
    const assettype = urlObj.searchParams.get('assettype');

    if (orientation) {
      setAssets([]);
      handleOrientationChange(orientation);
      setfiltereddata([orientation]);
    }
    if (assettype) {
      setfiltereddata([assettype]);

      setAssets([]);
      handleAssetType(assettype);
    }
  }, []);

  const toggle = () => {
    setModal(true);
    setshowupload(false);
    setaddcollection(false);
    setaddcollection(false);
  };

  const closeBtn = (
    <img
      src={close}
      className="close"
      onClick={() => setModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const options = {
    onUploadProgress: (progressEvent) => {
      const { loaded, total } = progressEvent;
      let percent = Math.floor((loaded * 100) / total);
      if (percent < 100) {
        setLoaded(loaded);
        setTotal(total);
        setUploadPercentage(percent);
      }
    },
  };

  const uploadFiles = async () => {
    setDisableDropBox(true);
    let data = new FormData();
    for (let i = 0; i < files.length; i++) {
      data.append('files', files[i]);
    }
    data.append('folderId', folderId);
    const res = await UploadFilesContext(data, files.length);
    setFiles(res?.data?.data);
    setUploadPercentage(100);
    setModal(false);
    navigate(-1);
    datashow();
  };

  const fetchFolder = async () => {};

  useEffect(() => {
    (async () => {
      try {
        const result = await Axios.get(GET_ASSET_TYPE_FILTER_DATA);
        setfilterAssetType(result?.data?.data);
      } catch (err) {
        console.error(err);
      }
    })();
    fetchFolder();
  }, []);

  useEffect(() => {
    if (isCollectionAdded) {
      // Reset the state after handling it
      setIsCollectionAdded(false);
    }
  }, [isCollectionAdded]);

  const fetchFolders = async () => {
    setIsLoading(true);

    try {
    } catch (error) {}
  };

  const getAllFolders = async (isErase = false) => {
    try {
      setIsLoading(true);

      const { data } = await Axios.get(
        folderdata +
          `?pageNo=${0}&rowSize=100&trash=${trash ? trash : false}&order=${sorting.value}`,
      ); //folderdata
      const _folders_data = {
        data: {
          folders: [
            {
              folders: data?.data?.folders?.flatMap((item) => item.folders),
            },
          ],
        },
      };

      const folderIds = data?.data?.folders
        ?.flatMap((item) =>
          item.folders.map((folder) => ({
            ...folder,
          })),
        )
        ?.map((folder) => folder?.id);

      const folder_related_color = await Axios.get(`${GET_FOLDER_COLORS}?folderIds=${folderIds}`);

      dispatch(
        SetSelctedFoldersData(
          data?.data?.folders?.flatMap((item) =>
            item.folders.map((folder) => ({
              ...folder,
              isSelected: selectedFolders?.find((d) => d.id === folder.id)?.isSelected ?? false,
              color: folder_related_color?.data?.data?.find((d) => d.folderId === folder.id)?.color,
            })),
          ),
        ),
      );

      setAllFoldersData(_folders_data);
      dispatch(setInsideFolderData(true));
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);

      console.error(err);
    }
  };

  // useEffect(() => {
  //   fetchFolders();
  //   dispatch(setInsideFolderData(true));
  //   getAllFolders();
  //   datashow();
  // }, []);

  const collectiondataadd = () => {
    setaddcollection(true);
  };

  const handleclose = () => {
    setaddcollection(false);
    setsubfolder([]);
  };

  const HanldeImageSave = async () => {
    datashow();
  };

  const closeBtn2 = (
    <img
      src={close}
      className="close"
      alt="closeicon"
      onClick={() => handleclose()}
      style={{ cursor: 'pointer' }}
    />
  );
  const closeBtnFolderAddition = (
    <img
      src={close}
      alt="close"
      className="close"
      onClick={() => setOpenFolderModal(false)}
      style={{ cursor: 'pointer' }}
    />
  );

  const folderaddded = async () => {
    setLoadingValue(true);
    if (!textvalue == '') {
      try {
        const formData = new FormData();
        formData.append('folderName', textvalue);
        const response = await Axios.post(Addfolder, formData);
        if (response.data.success) {
          // Folder created successfully, fetch updated folder data
          toast.success(response?.data?.message ?? 'Folder created successfully'); // Moved toast.success here
          setLoadingValue(false);
          setOpenFolderModal(false);
          getAllFolders();
        } else {
          // Handle error case
        }
      } catch (error) {
        setLoadingValue(false);
        toast.error(error.response.data.message);

        // Handle error
      }
    } else {
      toast.error('Please enter a valid folder name');
    }
    // Close the modal
  };

  const onScroll = useCallback(() => {
    const el = scrollRef?.current || listInnerRef.current;
    if (!el || isLoading || !isAvailableData) return;

    const { scrollTop, scrollHeight, clientHeight } = el;

    if (scrollTop + clientHeight >= scrollHeight - 1000) {
      setMetaData((prev) => {
        if (prev.isScrolling) return prev;
        return {
          ...prev,
          currentPage: prev.currentPage + 1,
          isScrolling: true,
          external: 'no',
        };
      });
    }
  }, [isLoading, isAvailableData, scrollRef]);

  // Attach scroll listener to the EXTERNAL scrollRef when it exists
  useEffect(() => {
    const el = scrollRef?.current;
    if (!el) return;

    el.addEventListener('scroll', onScroll);
    return () => el.removeEventListener('scroll', onScroll);
  }, [onScroll, scrollRef]);

  // Keep the internal scroll handler for when there's no external ref
  useEffect(() => {
    if (!scrollRef?.current) {
      setScrollHandler(() => onScroll);
    }
  }, [onScroll, scrollRef]);

  // const onScroll = useCallback(() => {
  //   const el = scrollRef.current || listInnerRef.current;
  //   if (!el || isLoading || !isAvailableData) return;

  //   const { scrollTop, scrollHeight, clientHeight } = el;

  //   // Trigger slightly before bottom
  //   if (scrollTop + clientHeight >= scrollHeight - 1000) {
  //     setMetaData((prev) => {
  //       if (prev.isScrolling) return prev; // guard
  //       return {
  //         ...prev,
  //         currentPage: prev.currentPage + 1,
  //         isScrolling: true,
  //         external: 'no',
  //       };
  //     });
  //   }
  // }, [isLoading, isAvailableData]);

  useEffect(() => {
    setScrollHandler(() => onScroll);
  }, [onScroll]);

  useEffect(() => {
    function handleClickOutside(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setImageSearchModal(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const assetsRef = useRef(selectedAssets);
  const folderRef = useRef(selectedFolders);

  useEffect(() => {
    assetsRef.current = selectedAssets;
    folderRef.current = selectedFolders;
  }, [selectedAssets, selectedFolders]);
  const cleanerFunction = (data) => {
    dispatch(
      SelectedAssetData(
        assetsRef.current?.map((item) => ({
          ...item,
          isSelected: false,
        })),
      ),
    );
    dispatch(
      SetSelctedFoldersData(
        folderRef.current?.map((item) => ({
          ...item,
          isSelected: false,
        })),
      ),
    );
  };
  // useEffect(() => {
  //   function handleClickOutside(e) {
  //     if (
  //       box1Ref.current &&
  //       !box1Ref.current.contains(e.target) &&
  //       box2Ref.current &&
  //       !box2Ref.current.contains(e.target) &&
  //       box3Ref.current &&
  //       !box3Ref.current.contains(e.target)
  //     ) {
  //       cleanerFunction(assetsRef.current); // always latest value
  //       // also latest here
  //     }
  //   }

  //   document.addEventListener('mousedown', handleClickOutside);
  //   return () => document.removeEventListener('mousedown', handleClickOutside);
  // }, []);
  return (
    <>
      <Modal
        isOpen={visualSearchModal.open}
        toggle={() => {
          setVisualSearchModal({});
        }}
        size="xl"
        style={{ width: '50%' }}
      >
        <ModalHeader toggle={toggle} close={closeBtn}>
          Reverse Image
        </ModalHeader>
        <ModalBody className="">
          {visualSearchModal.data && (
            <div className="d-flex justify-content-center">
              <div className="previewImage">
                <img src={URL.createObjectURL(visualSearchModal.data)} alt="preview" />
              </div>
            </div>
          )}
          <div
            style={{
              maxHeight: '70vh',
              overflow: 'auto',
            }}
          >
            <div className="mt-2">
              <Assitdata
                assets={visualSearchModal?.resultValue?.map((item) => ({ ...item }))}
                datashow={datashow}
                show={true}
                showData={false}
                collectionID={collectionID}
                showRenderActionButton={false}
                collectionName={collection_name}
                showCopyLing={false}
                gridNumber={3}
                single={single}
                accept={accept}
                trash={trash}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
      <Modal isOpen={modal} toggle={toggle} size="xl" style={{ width: '50%' }}>
        <ModalHeader toggle={toggle} close={closeBtn}>
          {currentModalFolderName}
        </ModalHeader>
        <ModalBody className="">
          <Uploadfile
            loadedData={loadedData}
            totalData={totalData}
            disableDropBox={disableDropBox}
            uploadPercentage={uploadPercentage}
            uploadFiles={uploadFiles}
            files={files}
            setFiles={setFiles}
            previewFlag={previewFlag}
            setPreviewFlag={setPreviewFlag}
          />
        </ModalBody>
      </Modal>

      <Modal isOpen={addcollection} toggle={collectiondataadd} size="xl" style={{ width: '50%' }}>
        <ModalHeader toggle={collectiondataadd} close={closeBtn2}>
          Upload
        </ModalHeader>
        <ModalBody>
          {isLoading ? (
            <SpinnerLoader />
          ) : (
            <div
              style={{
                maxHeight: '50vh',
                minHeight: '50vh',
                overflowX: 'hidden',
                overflowY: 'auto',
              }}
            >
              <FolderData isPoppedUp={true} HandleSave={HanldeImageSave} />
            </div>
          )}
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}></ModalFooter>
      </Modal>

      <Modal
        isOpen={openFolderModal}
        toggle={() => {
          setOpenFolderModal(!openFolderModal);
        }}
        style={{ width: '50%' }}
      >
        <ModalHeader
          toggle={() => {
            setOpenFolderModal(!openFolderModal);
          }}
          close={closeBtnFolderAddition}
        >
          Add Folder
        </ModalHeader>
        <ModalBody>
          <InputC
            type="text"
            label="Folder Name"
            name="textvalue"
            placeholder="Enter name of folder"
            change={(e) => {
              settextvalue(e.target.value);
            }}
          />
        </ModalBody>
        <ModalFooter style={{ borderTop: 'none' }}>
          <ButtonC
            text="Close"
            click={() => setOpenFolderModal(false)}
            size="lg"
            color="Secondary"
          />
          <ButtonC text="" click={folderaddded} size="lg" disabled={loadingValue}>
            {' '}
            {loadingValue && <Spinner color="light" className="mx-1" size="sm" />} Save
          </ButtonC>
        </ModalFooter>
      </Modal>

      <div
        className="mb-2 d-flex justify-content-between mt-4 no-print"
        style={{
          position: 'relative',
        }}
      >
        <div className="d-flex gap-1 relative">
          <SearchUI
            mode={mode}
            setMode={setMode}
            imageSearchModal={imageSearchModal}
            setImageSearchModal={setImageSearchModal}
            search={search}
            setSearch={setSearch}
            trash={trash}
            advancedSearchOpen={advancedSearchOpen}
            toggleAdvancedSearch={() => setAdvancedSearchOpen((previous) => !previous)}
            advancedFilterCount={advancedFilters.length}
          />
        </div>

        <div className="d-flex gap-2" ref={box3Ref}>
          {(selectedAssets?.filter((item) => item?.isSelected)?.length > 0 ||
            selectedFolders?.filter((item) => item?.isSelected)?.length > 0) &&
          !fromBrandAssets ? (
            <SelectionActions
              handleDelete={() => {
                datashow(true);
                getAllFolders(true);
              }}
              HandleAssetMove={() => {
                datashow(true);
                getAllFolders(true);
              }}
              HandleFolderCreation={() => {
                getAllFolders();
              }}
              trash={trash}
            />
          ) : (
            <div
              className="d-flex justify-content-end relative"
              style={{
                position: 'relative',
                gap: '10px',
                alignItems: 'center',
              }}
            >
              <TabToggle
                items={[
                  {
                    id: 1,
                    activeIcon: activegrid,
                    inactiveIcon: inactivegrid,
                  },
                  {
                    id: 2,
                    activeIcon: activelist,
                    inactiveIcon: inactivelist,
                  },
                ]}
                defaultValue={1}
                selected={selectedTab}
                onChange={(id) => {
                  setSelectedTab(id);
                  localStorage.setItem('damAssetsView', id);
                }}
              />

              {hasDAMAccess && !fromBrandAssets && !trash && (
                <CommonSidePortal
                  activeId={activeId}
                  setActiveId={setActiveId}
                  portalId={0}
                  ViewSection={
                    !collectionID && (
                      <ButtonC
                        size="lg"
                        click={() => {
                          // setOpenAdditionDialog(!openAdditionDialog);
                        }}
                      >
                        <span className="d-flex gap-2 justify-content-center items-center text-center align-items-center">
                          {DAM_SVG?.additionIconSvg} Add
                        </span>
                      </ButtonC>
                    )
                  }
                  OpenSection={
                    <div className="openAdditionDialog">
                      <div
                        onClick={() => {
                          dispatch(setInnerFolderDetails());
                          navigate('/dam/v2/uploads');
                        }}
                      >
                        {DAM_SVG.uploadSvgIcon} Asset Upload
                      </div>
                      <div
                        onClick={() => {
                          setActiveId();
                          setOpenFolderModal(true);
                          setOpenAdditionDialog(false);
                        }}
                      >
                        {DAM_SVG.addiitonSvgIcon} New Folder
                      </div>
                    </div>
                  }
                />
              )}
            </div>
          )}
        </div>

        {/* Absolutely positioned so it spans the toolbar width without joining
            the flex row above it. */}
        <AdvancedSearch
          isOpen={advancedSearchOpen}
          rows={advancedRows}
          setRows={setAdvancedRows}
          onClose={() => setAdvancedSearchOpen(false)}
          onClear={clearAdvancedSearch}
          onSearch={(filters) => {
            setAdvancedFilters(filters);
            setAdvancedSearchOpen(false);
          }}
        />
      </div>
      <div
        className="div-width-print"
        style={{
          position: 'relative',
        }}
      >
        <div className="visible-visibility d-flex justify-content-end ">
          {' '}
          <div
            className="d-flex justify-content-end mt-2"
            style={{
              width: '100%',
            }}
          >
            <div
              onClick={() => {
                setOpenFolderSection(!openFolderSection);
              }}
            >
              {' '}
              {SVG.filterIcon}
            </div>
          </div>
        </div>

        <div className="responsive_display_layout justify-content-between align-items-center">
          <div
            className={`d-flex align-items-center gap-2 mt-4  ${openFolderSection ? 'threedotsiconclickfunction2nd openFolderSectionDesign' : 'hidden-visibility'} `}
          >
            <Viewbuttonfolderv2
              text="Asset Type" // Label Name
              value="assettype" // for checking eith the tab is actio
              onSelectFilter={handleAssetType} // handleing after selction checkbox
              selectedFormats={filterAssetType} // FIlter Data
              setDesignationdata={setDesignationdata}
              inputSearch={searchExtesionValue} //Search Value
              setInputSearch={setSearchExtensionValue} // set Search Value
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectassettype} // Data which is visible in
              isExtension={isExtension} // check is extension or not
              setIsExtension={setIsExtension} // set value of exgtension
              isSubFilter={true} // for showing the vlaue on right side
              trash={trash}
            />
            <Viewbuttonfolderv2
              text="Orientation"
              value="orientations"
              onSelectFilter={handleOrientationChange}
              selectedFormats={[
                { id: 1, label: 'Landscape' },
                { id: 2, label: 'Portrait' },
                { id: 3, label: 'Square' },
              ]}
              setDesignationdata={setDesignationdata}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectorientation}
              trash={trash}
            />

            <Viewbuttonfolderv2
              text="Creation Date"
              value="creationDate"
              onSelectFilter={(value) => {
                setselectdate(selectdate === value ? '' : value);
                setSelectDateValidator(selectdate === value ? [] : [value]);
              }}
              selectedFormats={[
                { id: 0, label: 'Today' },
                { id: 7, label: 'Last 7 days' },
                { id: 30, label: 'Last 30 days' },
                { id: 90, label: 'Last 90 days' },
                { id: 180, label: 'Last 180 days' },
              ]}
              today={today}
              setDesignationdata={setDesignationdata}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selecttDateValidator}
              setcreatedon={setcreatedon}
              createdon={createdon}
              customValue={iscustomValue}
              setCustomValue={setIsCustomValue}
              trash={trash}
            />

            <Viewbuttonfolderv2
              text="Folder"
              value="folder"
              datashow={datashow}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={folderselect}
              setstate={setfolderselect}
              trash={trash}
            />
            <Viewbuttonfolderv2
              text="Color"
              value="color"
              datashow={datashow}
              selectedValue={selectedColor}
              onSelectFilter={setSelectedColor}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectedColor}
              setstate={setfolderselect}
              trash={trash}
            />
            <Viewbuttonfolderv2
              text="Faces"
              value="face"
              datashow={datashow}
              selectedValue={selectedFace}
              onSelectFilter={setSelectedFace}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={selectedFace}
              setstate={setfolderselect}
              trash={trash}
            />

            {hasFullDAMAccess && (
              <Viewbuttonfolderv2
                text="Uploaded By"
                value="uploadedby"
                onSelectFilter={(value) => {
                  if (uploadedData?.includes(value)) {
                    setUploadedData([]);
                  } else {
                    setUploadedData([value]);
                  }
                }}
                selectedFormats={[
                  { id: 1, label: 'By me' },
                  { id: 2, label: 'By Others' },
                ]}
                today={today}
                setDesignationdata={setDesignationdata}
                Designationdata={Designationdata}
                setfiltereddata={setfiltereddata}
                filtereddata={uploadedData}
                state={uploadedData}
                setcreatedon={setcreatedon}
                createdon={createdon}
                trash={trash}
              />
            )}

            <Viewbuttonfolderv2
              text="Tags"
              value="tags"
              datashow={datashow}
              selectedFormats={[]}
              setDesignationdata={setDesignationdata}
              datafilter={datafilter}
              Designationdata={Designationdata}
              setfiltereddata={setfiltereddata}
              filtereddata={filtereddata}
              state={tagValue}
              setstate={setTagValue}
              trash={trash}
            />
            <button className="resetbtn" onClick={handlereset}>
              Reset
            </button>
          </div>

          <div className="d-flex justify-content-end">
            <CommonTableDrived
              Label="Sort By"
              ClickedValue={(value) => {
                setSorting(value);
              }}
              selectedValueData={sorting}
              Option={sortOptions}
            />
          </div>
        </div>
      </div>

      <div
        style={{
          marginTop: '1rem',
        }}
      >
        {selectedTab === 2 ? (
          <></>
        ) : (
          <div ref={box1Ref}>
            <GridFolderData
              isPoppedUp={true}
              isUpload={false}
              data={allFoldersData}
              setdata={setAllFoldersData}
              innerfolderValue={isInsideFolder}
              HandleDelete={() => {
                getAllFolders();
                datashow();
              }}
              showPagination={false}
              fromBrandAssets={fromBrandAssets}
              setfolderId={setselectedfolderId}
              selectedfolderid={selectedfolderid}
              trash={trash}
            />
          </div>
        )}

        {isInsideFolder && (
          <>
            {assets?.files?.length === 0 && isLoading ? (
              <div className=" d-flex align-item-center justify-content-center">
                {isLoading ? (
                  <div className="w-10">
                    <Spinner />
                  </div>
                ) : (
                  <div className="w-50">
                    <Nodatacomponent text={'No Asset Found'} />
                  </div>
                )}
              </div>
            ) : (
              <div className="RerativeClass">
                {selectedTab === 1 && (
                  <div ref={box2Ref}>
                    <Assitdata
                      assets={assets?.files?.map((item) => ({ ...item }))}
                      datashow={datashow}
                      show={true}
                      showData={false}
                      collectionID={collectionID}
                      showRenderActionButton={false}
                      collectionName={collection_name}
                      showCopyLing={false}
                      fromBrandAssets={fromBrandAssets}
                      setselectedfolderId={setselectedfolderId}
                      accept={accept}
                      single={single}
                      trash={trash}
                    />
                  </div>
                )}

                {selectedTab === 2 && (
                  <CommonTable
                    data={[
                      ...(Array.isArray(selectedFolders)
                        ? selectedFolders.map((item) => ({
                            ...item,
                            assetName: item?.folderName,
                            assetType: 'Folder',
                            type: 'assetsFolder',
                            typeIdentification: 1,
                          }))
                        : []),
                      ...(Array.isArray(assets?.files)
                        ? assets.files.map((item) => ({
                            ...item,
                            type: 'assetsImage',
                            typeIdentification: 2,
                          }))
                        : []),
                    ]}
                    setAssets={setAssets}
                    files={assets?.files ?? []}
                    HandleDelete={() => {
                      getAllFolders();
                      datashow();
                    }}
                    fromBrandAssets={fromBrandAssets}
                    setselectedfolderId={setselectedfolderId}
                    accept={accept}
                    single={single}
                    trash={trash}
                  />
                )}

                {isLoading && (
                  <div
                    style={{
                      position: 'absolute',
                      bottom: 0,
                      right: '50%',
                    }}
                  >
                    <Spinner />
                  </div>
                )}
              </div>
            )}
          </>
        )}
      </div>
    </>
  );
};

export default AssetsData;
